import { validateItem } from './validateItem'
import { RemoteConfig, Step } from '@ca/common/types'
import { Refraction } from '@ca/common'
import { VariableValues } from './OrderVariables'

export const resolveCustomOptions = ({
  config,
  refraction,
  step,
  values,
}: {
  config: RemoteConfig
  refraction: Refraction
  step: Step
  values: VariableValues
}) => {
  const customOptions = step.customOptions.map((id) => config.customOptions[id])
  const items = customOptions.filter((option) =>
    validateItem(option, values, config.conditions, refraction).result
  )
  return items
}
